import DataStorage from './DataStorage';

export default class Status {

    /** possible statuses */
    static INITIAL = 'INITIAL';
    static EXPIRED = 'EXPIRED';
    static SKIPPED = 'SKIPPED';
    static SKIPPED_DISCLAIMER = 'SKIPPED:DISCLAIMER';
    static RUNNING = 'RUNNING';
    static RUNNING_LONGER = 'RUNNING:TAKES_LONGER';
    static RUNNING_VERY_LONG = 'RUNNING:TAKES_VERY_LONG';
    static ERROR = 'ERROR';
    static SUCCESS = 'SUCCESS';
    static UNAVAILABLE = 'UNAVAILABLE';
    static UPGRADEABLE = 'UPGRADEABLE';

    getStatus(backendStatus: string) {
        switch (backendStatus) {
            case 'INITIAL':
                return Status.INITIAL;

            case 'RUNNING':
                if (DataStorage.getSecondsPassedFromMigrationStart() < 5 * 60) {
                    return Status.RUNNING;
                } else {
                    return Status.RUNNING_LONGER;
                }

            case 'RUNNING:TAKES_LONGER':
                return Status.RUNNING_LONGER;

            case 'RUNNING:TAKES_VERY_LONG':
                return Status.RUNNING_VERY_LONG;

            case 'ERROR':
                return Status.ERROR;

            case 'SUCCESS:MIGRATION_FINISHED':
                return Status.SUCCESS;

            case 'SKIPPED':
                return Status.SKIPPED;

            case 'SKIPPED:DISCLAIMER':
                return Status.SKIPPED_DISCLAIMER;

            case 'EXPIRED':
                return Status.EXPIRED;

            case 'UPGRADEABLE':
                return Status.UPGRADEABLE;

            default:
                return Status.UNAVAILABLE;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/Status.ts
 **/